import styled from "styled-components";

export const Square7Style = styled.div`
width:100%;
height:100%;
  .img-fluid {
    display: block;
    max-width: 100%;
  }

  .container8 {
    width:100%;
    height:100%;
    overflow: hidden;
  }

  .f-white {
    color: #fff;
  }

  .text-wrapper div {
    width:100%
  }

  .back-layer {
    width:100%;
   height:100%;
    background: #2f7dff;
    background: -moz-linear-gradient(left, #2f7dff 0%, #ff48d2 100%);
    background: -webkit-linear-gradient(left, #2f7dff 0%, #ff48d2 100%);
    background: linear-gradient(to right, #2f7dff 0%, #ff48d2 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2f7dff', endColorstr='#ff48d2',GradientType=1 );
  }

  .back-layer img,
  .back-layer video {
    width:100%;
    height:100%;
    object-fit: cover;
    object-position: center;
    opacity: 0.7;
  }

  .text-wrapper {
    position: absolute;
    bottom: -50%;
    left: 0;
    right: 0;
    background: #2f7dffd6;
    width:100%;
    height:40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5%;
  }

`
;
